module.exports = __webpack_public_path__ + "img/logo.e73d7b4c.png";